import styled from 'styled-components/macro';
import {
  BREAKPOINTS,
  COLORS,
  FLEX_CONTAINER,
  FONTS,
  FONT_FAMILY,
} from 'utils/styles';

export const CalendarContent = styled.div`
  width: 100%;
  height: 310px;
  padding-left: 28px;
  margin-top: 20px;
  position: relative;
  @media ${BREAKPOINTS.xl} {
    padding-left: 28px;
  }

  @media ${BREAKPOINTS.lg} {
    padding-left: 28px;
  }

  @media ${BREAKPOINTS.md} {
    padding-left: unset;
  }
  .questionCalendar {
    border: 1px solid #0f425a;
    width: 250px;
    border-radius: 14px;
    height: 48px;
    text-align: center;
    margin-top: 30px;
    background-color: transparent;
    color: ${COLORS.mainColor};
    ${FONTS.font16};
    ${FONT_FAMILY.FontMedium}
  }
  .react-datepicker__triangle {
    transform: translate(128px, 0px) !important;
  }
  .react-datepicker {
    margin-left: 25px;
    @media ${BREAKPOINTS.sm} {
      margin-left: 0;
    }
  }
`;

export const QuestionText = styled.label`
  color: ${COLORS.mainColor};
  ${FONTS.font20};
  ${FONT_FAMILY.FontMedium};
`;

export const CustomInput = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  width: 300px;
  height: 48px;
  margin-top: 30px;
  @media ${BREAKPOINTS.sm} {
    width: 250px;
  }
`;
export const ExampleCustomInput = styled.button`
  ${FLEX_CONTAINER.FlexCenterRow};
  border: 1px solid #0f425a;
  width: 145px;
  border-radius: 14px;
  height: 48px;
  text-align: center;
  background-color: transparent;
  color: ${COLORS.black};
  ${FONTS.font12};
  ${FONT_FAMILY.FontRegular};
  @media ${BREAKPOINTS.sm} {
    width: 120px;
  }
`;

export const CalendarIcon = styled.img`
  width: 18px;
  height: 20px;
  object-fit: contain;
  margin-right: 6px;
`;
